import { Injectable, NgModule } from '@angular/core';
import { DataApiService, BaseService } from '@xpo-ltl/data-api';
import { ConfigManagerService, CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@xpo-ltl/data-api';
import * as ɵngcc2 from '@xpo-ltl/config-manager';
class UserPreferenceApiService extends BaseService {
    /**
     * @param {?} dataApiService
     * @param {?} configManager
     */
    constructor(dataApiService, configManager) {
        super();
        this.dataApiService = dataApiService;
        this.configManager = configManager;
    }
    /**
     * Health check URL. Responds with success message if the service is running.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    healthCheck(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/health-check'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List of resources.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    options(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/options'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Details of user invoking the API.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    loggedInUser(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/appusers/logged-in-user'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Deletes user preference by ID.
     * <br/>
     * <br/>Primary Parameter:
     * <br/>- userPrefId. The user preference instance ID for which to delete the preferences.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteUserPreferenceById(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preferences/{userPrefId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation deletes a user preference based on the application name provided.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid appName must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If the input provided is valid, then the user preference associated with it is deleted.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteUserPreferencesByAppName(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/apps/{applicationName}/user-preferences'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * Returns user preferences. The user id and application name are derived from the API subscription and passed in the transaction context.
     * <br/>
     * <br/>Optional Parameters:
     * <br/>- uiComponentName. The UI component for which to retrieve the preferences
     * <br/>- uiComponentDefault. A boolean indicating whether to retrieve the default preferences for the UI component.
     * <br/>- appDefault. A boolean indicating whether to retrieve the default preferences for the application. Cannot be combined with the UI Component options
     * <br/>- globalDefault. A boolean indicating whether to retrieve the global preferences. Cannot be combined with either app default or UI Component options.
     * <br/>
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getUserPreference(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/users/preferences'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Get user preference by identifier.
     * <br/>        Primary Parameter:
     * <br/>        	- userPrefId. The user preference instance id for which to retrieve the preferences.
     * <br/>
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getUserPreferenceById(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preferences/{userPrefId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Inserts or Updates user preferences. The user id and application name are derived from the API subscription
     * <br/>        and passed in the transaction context.
     * <br/>        Optional Parameters:
     * <br/>        	- uiComponentName. The UI component for which to store the preferences
     * <br/>        	- uiComponentDefault. A boolean indicating whether to upsert the default preferences for the UI component.
     * <br/>        	- appDefault. A boolean indicating whether to upsert the default preferences for the application. Cannot be combined
     * <br/>        	with the UI Component options
     * <br/>        	- globalDefault. A boolean indicating whether to upsert the global preferences. Cannot be combined
     * <br/>        	with either app default or UI Component options
     * <br/>
     * @param {?} request
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    upsertUserPreference(request, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/users/preferences'), {
            queryParams: queryParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation deletes a customer group that are associated with preference groupings and group items. This is an exclusive operation for the Shipment Management app.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid groupingId must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the customer group associated with the identifier provided is deleted.
     * <br/>2. Otherwise an appropriate error message is returned.
     * <br/>
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteCustomerGroup(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/customer-groups/{groupingId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation deletes a preference group item that contains its own preference criteria stored as a CLOB.  The user ID and application name are derived from the API subscription and passed in the transaction context.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid groupingId and businessKey (Customer or Shipment) are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the Group Item record is deleted.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteGroupItem(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/{groupingId}/group-items/{businessKey}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation lists all customer groups that are associated with preference groupings and group items for a particular UI component. This is an exclusive operation for the Shipment Management app.
     * <br/>
     * <br/>Pre-condition:
     * <br/>None
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then all customer groups that match the filter criteria will be listed.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listCustomerGroups(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/customer-groups'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation upserts a customer group that contains its own preference criteria stored as a clob.  The user ID and application name are derived from the API subscription and passed in the transaction context. This is an exclusive operation for the Shipment Management app.
     * <br/>
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid groupingName and groupingPreference must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the customer group will be created or updated if it already exists.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    upsertCustomerGroup(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/customer-groups'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation upserts a preference group item associated with preference grouping and either a customer record or shipment record.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid GroupItem is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the GroupItem will be upserted.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    upsertGroupItem(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/group-items'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Delete existing preference grouping.
     * <br/>        Primary Parameter:
     * <br/>        	- groupingInstId. Unique ID for a preference grouping
     * <br/>
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deletePreferenceGrouping(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/{groupingInstId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * Get the details about a preference grouping. The user id and application name are derived from the API subscription and passed in the transaction context.
     * <br/>        Primary Parameter:
     * <br/>        	- groupingInstId. Unique ID for a preference grouping.
     * <br/>
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getPreferenceGrouping(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/{groupingInstId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List all preference groupings. The user id and application name are derived from the API subscription and passed in the transaction context.
     * <br/>        Optional Parameters:
     * <br/>        	- uiComponentName. The UI component for which to retrieve the preferences
     * <br/>        	- listInfo. Filter and pagination criteria.
     * <br/>
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listAllPreferenceGroupings(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/all'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List all preference grouping details that are assigned to a user.
     * <br/>        Optional Parameters:
     * <br/>        	- uiComponentName. The UI component for which to retrieve the preferences
     * <br/>        	- listInfo. Filter and pagination criteria.
     * <br/>        Primary Parameter:
     * <br/>           	- userId. Id of the user for which to retrieve the preference groupings.
     * <br/>
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listPreferenceGroupingsForUser(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/users/{userId}/preference-groupings'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List user preferences for preference grouping by grouping id.
     * <br/>        Primary Parameter:
     * <br/>        	- groupingInstId. Unique ID for a customer grouping.
     * <br/>
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listUserPreferencesForPreferenceGrouping(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/{groupingInstId}/preferences'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List all users that are attached to a preference grouping
     * <br/>        Primary Parameter:
     * <br/>        	- groupingInstId. Unique ID for a preference grouping
     * <br/>
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listUsersForPreferenceGrouping(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/{groupingInstId}/users'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation upserts a preference grouping that contains its own preference criteria stored as a clob.  The user ID and application name are derived from the API subscription and passed in the transaction context.
     * <br/>
     * <br/>
     * <br/>Primary Parameters:
     * <br/>- groupingName
     * <br/>- groupingPreference
     * <br/>
     * <br/>Optional Parameter:
     * <br/>- uiComponentName
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    upsertPreferenceGrouping(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation upserts a User Preference and attaches it to an existing Preference grouping that contains its own preference criteria stored as a clob.  The user ID and application name are derived from the API subscription and passed in the transaction context.
     * <br/>
     * <br/>Primary Parameters:
     * <br/>- uiComponentName: the UI component for which to create the preferences.
     * <br/>- groupingInstId: the unique ID of the preference group to be attached to the user preference.
     * <br/>- userPreference: the User Preference object to be created.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    upsertUserPreferenceForPreferenceGrouping(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/preferences'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation deletes an existing Preference Grouping Tool.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid groupingId and toolPreferredSequenceNbr must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the Preference Grouping Tool is deleted.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deletePreferenceGroupingTool(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/{groupingId}/tool-preferences/{toolPreferenceSequenceNbr}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation gets the details about a Preference Grouping Tool. The user ID and application name are derived from the API subscription and passed in the transaction context.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getPreferenceGroupingTool(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/{groupingId}/tool-preferences/{toolPreferenceSequenceNbr}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists preference groupings. The user ID and application name are derived from the API subscription and passed in the transaction context.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid groupName must be provided.
     * <br/>2. Optional filter parameters:
     * <br/>- uiComponentName
     * <br/>- filterKey1
     * <br/>- filterKey2
     * <br/>- filterKey3
     * <br/>- filterKey4
     * <br/>- filterKey5
     * <br/>- listInfo
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the preference grouping tools that match the input criteria will be listed.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listPreferenceGroupingTools(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/{groupingName}/tool-preferences'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation upserts a preference grouping tool that contains its own preference criteria stored as a clob.  The user ID and application name are derived from the API subscription and passed in the transaction context.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. The input fields provided must be valid.
     * <br/>
     * <br/>Post-conditions:
     * <br/>Post-condition:
     * <br/>1. If the upsert is successful, then either the entry will be updated if it already exists or if it doesn't, then it will be created.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    upsertPreferenceGroupingTool(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-grouping-tools'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Attach an existing preference grouping to the user.
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createPreferenceGroupingUser(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-groupings/users'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Delete a user from an existing preference grouping.
     * <br/>        Primary Parameter:
     * <br/>        	- groupingInstId. Unique ID for a preference grouping
     * <br/>        	- userId. ID for for the user to be removed from the preference grouping
     * <br/>
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deletePreferenceGroupingUser(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/preference-grouping/{groupingInstId}/users/{userId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * @return {?}
     */
    getEndPoint() {
        return this.configManager.getSetting(UserPreferenceApiService.UserPreferenceApiEndpoint);
    }
}
UserPreferenceApiService.ɵfac = function UserPreferenceApiService_Factory(t) { return new (t || UserPreferenceApiService)(ɵngcc0.ɵɵinject(ɵngcc1.DataApiService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigManagerService)); };
UserPreferenceApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UserPreferenceApiService, factory: UserPreferenceApiService.ɵfac });
UserPreferenceApiService.UserPreferenceApiEndpoint = 'userpreferenceApiEndpoint';
/** @nocollapse */
UserPreferenceApiService.ctorParameters = () => [
    { type: DataApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserPreferenceApiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.DataApiService }, { type: ɵngcc2.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkUserPreferenceModule {
}
SdkUserPreferenceModule.ɵfac = function SdkUserPreferenceModule_Factory(t) { return new (t || SdkUserPreferenceModule)(); };
SdkUserPreferenceModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkUserPreferenceModule });
SdkUserPreferenceModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        UserPreferenceApiService,
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkUserPreferenceModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    UserPreferenceApiService,
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkUserPreferenceModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * UserPreference API
 * Version: 1.0
 * Build: 1.0.2.8
 */
/**
 * Path parameter which is used to delete a customer group.
 */
class DeleteCustomerGroupPath {
    constructor() {
        /**
         * The unique identifier for the customer group.
         * Required: true
         * Array: false
         */
        this.groupingId = undefined;
    }
}
/**
 * Path parameters which are used to delete a preference group item.
 */
class DeleteGroupItemPath {
    constructor() {
        /**
         * The identifier of the preference grouping.
         * Required: true
         * Array: false
         */
        this.groupingId = undefined;
        /**
         * Identifies the unique identifier of the Customer or Shipment in the grouping.
         * Required: true
         * Array: false
         */
        this.businessKey = undefined;
    }
}
/**
 * Request for deleteUserPreferenceById
 */
class DeleteUserPreferenceByIdPath {
    constructor() {
        /**
         * Id of userPreference instance.
         * Required: false
         * Array: false
         */
        this.userPrefId = undefined;
    }
}
/**
 * Query parameters used to retrieve a user's preferences.
 */
class DeleteUserPreferencesByAppNamePath {
    constructor() {
        /**
         * The name of the application.
         * Required: true
         * Array: false
         */
        this.applicationName = undefined;
    }
}
/**
 * Query parameters used to retrieve a user's preferences.
 */
class DeleteUserPreferencesByAppNameQuery {
    constructor() {
        /**
         * The name of the UI Component.
         * Required: false
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * The ID of the user that is associated with the preferences.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Query parameters used to retrieve a user's preferences.
 */
class GetUserPreferenceQuery {
    constructor() {
        /**
         * Id of user for whom the preferences are to be stored.
         * 					By default, the id is determined by the API gateway based on subscription.
         * 					The Id passed here will only be used when there is a generic subscription
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Name of the UI Component.
         * Required: false
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * If true, retrieve the UI component default preferences
         * Required: false
         * Array: false
         */
        this.uiComponentDefault = undefined;
        /**
         * If true, retrieve the application default preferences
         * Required: false
         * Array: false
         */
        this.appDefault = undefined;
        /**
         * If true, retrieve the global default preferences
         * Required: false
         * Array: false
         */
        this.globalDefault = undefined;
    }
}
/**
 * Response for getUserPreference
 */
class GetUserPreferenceResp {
    constructor() {
        /**
         * The preferences in JSON format
         * Required: false
         * Array: false
         */
        this.preferences = undefined;
    }
}
/**
 * Request for getUserPreferenceById
 */
class GetUserPreferenceByIdPath {
    constructor() {
        /**
         * Id of userPreference instance.
         * Required: true
         * Array: false
         */
        this.userPrefId = undefined;
    }
}
/**
 * Response for getUserPreferenceById
 */
class GetUserPreferenceByIdResp {
    constructor() {
        /**
         * The user preference details.
         * Required: false
         * Array: false
         */
        this.userPreference = undefined;
    }
}
/**
 * Query parameters which are used to list customer groups.
 */
class ListCustomerGroupsQuery {
    constructor() {
        /**
         * The name of the UI component.
         * Required: false
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the request to list customer groups.
 */
class ListCustomerGroupsResp {
    constructor() {
        /**
         * The list of customer groups.
         * Required: false
         * Array: true
         */
        this.customerGroups = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Request to upsert a preference group item.
 */
class UpsertGroupItemRqst {
    constructor() {
        /**
         * The preference group item that will update an existing entry or create a new one.
         * Required: true
         * Array: false
         */
        this.groupItem = undefined;
    }
}
/**
 * Response to the request to upsert a preference group item.
 */
class UpsertGroupItemResp {
    constructor() {
        /**
         * The preference group item that was upserted.
         * Required: true
         * Array: false
         */
        this.groupItem = undefined;
    }
}
/**
 * Query parameter used to upsert a user preference.
 */
class UpsertUserPreferenceQuery {
    constructor() {
        /**
         * Id of user for whom the preferences are to be stored.
         * 					By default, the id is determined by the API gateway based on subscription.
         * 					The Id passed here will only be used when there is a generic subscription
         * Required: false
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Request for upsertUserPreference
 */
class UpsertUserPreferenceRqst {
    constructor() {
        /**
         * Name of the UI Component. If omitted, upsert the default preferences for the UI component
         * Required: false
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * If true, upsert the UI component default preferences
         * Required: false
         * Array: false
         */
        this.uiComponentDefault = undefined;
        /**
         * If true, upsert the application default preferences
         * Required: false
         * Array: false
         */
        this.appDefault = undefined;
        /**
         * If true, upsert the global default preferences
         * Required: false
         * Array: false
         */
        this.globalDefault = undefined;
        /**
         * The preferences in JSON format
         * Required: false
         * Array: false
         */
        this.preferences = undefined;
        /**
         * Id of user for whom the preferences are to be stored.
         * 					By default, the id is determined by the API gateway based on subscription.
         * 					The Id passed here will only be used when there is a generic subscription
         * Required: false
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Request for createPreferenceGroupingUser
 */
class CreatePreferenceGroupingUserRqst {
    constructor() {
        /**
         * unique identifier of Preference Grouping
         * Required: true
         * Array: false
         */
        this.groupingInstId = undefined;
        /**
         * User identifier
         * Required: true
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Request for deletePreferenceGrouping
 */
class DeletePreferenceGroupingPath {
    constructor() {
        /**
         * Id of preference grouping.
         * Required: true
         * Array: false
         */
        this.groupingInstId = undefined;
    }
}
/**
 * Request for deletePreferenceGroupingUser
 */
class DeletePreferenceGroupingUserPath {
    constructor() {
        /**
         * unique identifier of Preference Grouping
         * Required: true
         * Array: false
         */
        this.groupingInstId = undefined;
        /**
         * User identifier
         * Required: true
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Request for getPreferenceGrouping
 */
class GetPreferenceGroupingPath {
    constructor() {
        /**
         * Id of preference grouping.
         * Required: true
         * Array: false
         */
        this.groupingInstId = undefined;
    }
}
/**
 * Response for getPreferenceGrouping
 */
class GetPreferenceGroupingResp {
    constructor() {
        /**
         * Preference grouping applicable to the UI component/application (optional).
         * Required: false
         * Array: false
         */
        this.preferenceGrouping = undefined;
    }
}
/**
 * Response for listAllPreferenceGroupings
 */
class ListAllPreferenceGroupingsQuery {
    constructor() {
        /**
         * Name of the UI Component.
         * Required: false
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * The optional identifier of the user for which perference groupings will be returned.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response for listAllPreferenceGroupings
 */
class ListAllPreferenceGroupingsResp {
    constructor() {
        /**
         * The preference grouping instances.
         * Required: false
         * Array: true
         */
        this.preferenceGroupings = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Request for listPreferenceGroupingsForUser
 */
class ListPreferenceGroupingsForUserPath {
    constructor() {
        /**
         * Id of the user.
         * Required: true
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Request for listPreferenceGroupingsForUser
 */
class ListPreferenceGroupingsForUserQuery {
    constructor() {
        /**
         * Name of the UI Component.
         * Required: false
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Request for UpdateUserPreferencesForPreferenceGrouping
 */
class ListPreferenceGroupingsForUserResp {
    constructor() {
        /**
         * The preference grouping instances.
         * Required: false
         * Array: true
         */
        this.preferenceGroupings = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response for listUsersForPreferenceGrouping
 */
class ListUsersForPreferenceGroupingPath {
    constructor() {
        /**
         * Id of preference grouping.
         * Required: true
         * Array: false
         */
        this.groupingInstId = undefined;
    }
}
/**
 * Response for listUsersForPreferenceGrouping
 */
class ListUsersForPreferenceGroupingQuery {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response for listUsersForPreferenceGrouping
 */
class ListUsersForPreferenceGroupingResp {
    constructor() {
        /**
         * Users attached to a preference grouping.
         * Required: false
         * Array: true
         */
        this.preferenceGroupingUsers = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response for listUserPreferencesForPreferenceGrouping
 */
class ListUserPreferencesForPreferenceGroupingPath {
    constructor() {
        /**
         * Id of customer grouping.
         * Required: true
         * Array: false
         */
        this.groupingInstId = undefined;
    }
}
/**
 * Response for listUserPreferencesForPreferenceGrouping
 */
class ListUserPreferencesForPreferenceGroupingQuery {
    constructor() {
        /**
         * Id of the Application.
         * Required: false
         * Array: false
         */
        this.appInstId = undefined;
        /**
         * Name of the UI Component.
         * Required: false
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response for listUserPreferencesForPreferenceGrouping
 */
class ListUserPreferencesForPreferenceGroupingResp {
    constructor() {
        /**
         * The list of user preference details.
         * Required: false
         * Array: true
         */
        this.userPreferences = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Request to upsert a customer group.
 */
class UpsertCustomerGroupRqst {
    constructor() {
        /**
         * The name of the UI Component for which the customer group will be upserted.
         * Required: false
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * The preference grouping instance of the customer group that will be upserted.
         * Required: true
         * Array: false
         */
        this.preferenceGrouping = undefined;
    }
}
/**
 * Response to the request to upsert a customer group.
 */
class UpsertCustomerGroupResp {
    constructor() {
        /**
         * The preference grouping instance of the customer group that was upserted.
         * Required: false
         * Array: false
         */
        this.preferenceGrouping = undefined;
    }
}
/**
 * Request for upsertPreferenceGrouping
 */
class UpsertPreferenceGroupingRqst {
    constructor() {
        /**
         * The name of the UI Component for which the Preference Grouping is being upserted.
         * Required: false
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * The preference grouping instance.
         * Required: true
         * Array: false
         */
        this.preferenceGrouping = undefined;
    }
}
/**
 * Response for createPreferenceGrouping
 */
class UpsertPreferenceGroupingResp {
    constructor() {
        /**
         * The preference grouping that was upserted.
         * Required: false
         * Array: false
         */
        this.preferenceGrouping = undefined;
    }
}
/**
 * Request for upsertUserPreferenceForPreferenceGrouping
 */
class UpsertUserPreferenceForPreferenceGroupingRqst {
    constructor() {
        /**
         * The name of the UI Component for which the Preference Grouping is being created.
         * Required: true
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * The unique identifier of the preference group to be attached to the user preference.
         * Required: true
         * Array: false
         */
        this.groupingInstId = undefined;
        /**
         * The user preference grouping object to be upserted.
         * Required: true
         * Array: false
         */
        this.userPreference = undefined;
    }
}
/**
 * Response for upsertUserPreferenceForPreferenceGrouping
 */
class UpsertUserPreferenceForPreferenceGroupingResp {
    constructor() {
        /**
         * The user preference that was upserted.
         * Required: false
         * Array: false
         */
        this.userPreference = undefined;
    }
}
/**
 * Path parameter used to delete a preference grouping tool.
 */
class DeletePreferenceGroupingToolPath {
    constructor() {
        /**
         * The unique identifier of the Preference Grouping.
         * Required: true
         * Array: false
         */
        this.groupingId = undefined;
        /**
         * The sequence number associated with the Preference Grouping Tool.
         * Required: true
         * Array: false
         */
        this.toolPreferenceSequenceNbr = undefined;
    }
}
/**
 * Path parameters used to get a preference grouping tool.
 */
class GetPreferenceGroupingToolPath {
    constructor() {
        /**
         * The unique identifier of the Preference Grouping.
         * Required: true
         * Array: false
         */
        this.groupingId = undefined;
        /**
         * The sequence number associated with the Preference Grouping Tool.
         * Required: true
         * Array: false
         */
        this.toolPreferenceSequenceNbr = undefined;
    }
}
/**
 * Response to the request to get a preference grouping tool.
 */
class GetPreferenceGroupingToolResp {
    constructor() {
        /**
         * The preference grouping tool that matches the input provided.
         * Required: true
         * Array: false
         */
        this.preferenceGroupingTool = undefined;
    }
}
/**
 * Path parameter used to list preference grouping tools.
 */
class ListPreferenceGroupingToolsPath {
    constructor() {
        /**
         * The name of the Preference Grouping.
         * Required: true
         * Array: false
         */
        this.groupingName = undefined;
    }
}
/**
 * Query parameters that are used to filter the list of preference grouping tools.
 */
class ListPreferenceGroupingToolsQuery {
    constructor() {
        /**
         * The name of the UI Component for which the preference grouping tools will be retrieved.
         * Required: true
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * The first generic filter key value to identify the tool preference.
         * Required: true
         * Array: false
         */
        this.filterKey1 = undefined;
        /**
         * The second generic filter key value to identify the tool preference.
         * Required: true
         * Array: false
         */
        this.filterKey2 = undefined;
        /**
         * The third generic filter key value to identify the tool preference.
         * Required: true
         * Array: false
         */
        this.filterKey3 = undefined;
        /**
         * The fourth generic filter key value to identify the tool preference.
         * Required: true
         * Array: false
         */
        this.filterKey4 = undefined;
        /**
         * The fifth generic filter key value to identify the tool preference.
         * Required: true
         * Array: false
         */
        this.filterKey5 = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: true
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the request to list preference grouping tools that match the input criteria.
 */
class ListPreferenceGroupingToolsResp {
    constructor() {
        /**
         * The preference grouping tools that matches the input provided.
         * Required: false
         * Array: true
         */
        this.preferenceGroupingTools = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: true
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Request to upsert a preference grouping tool.
 */
class UpsertPreferenceGroupingToolRqst {
    constructor() {
        /**
         * The preference grouping tool that will update an existing entry or create a new one.
         * Required: true
         * Array: false
         */
        this.preferenceGroupingTool = undefined;
    }
}
/**
 * Response to the request to upsert a preference grouping tool.
 */
class UpsertPreferenceGroupingToolResp {
    constructor() {
        /**
         * The preference grouping tool that will update an existing entry or create a new one.
         * Required: true
         * Array: false
         */
        this.preferenceGroupingTool = undefined;
    }
}
/**
 * Contains combined information from preference grouping and group item.
 */
class PreferenceCustomerGroup {
    constructor() {
        /**
         * The identifier of the customer group.
         * Required: false
         * Array: false
         */
        this.groupingId = undefined;
        /**
         * The name of the customer group.
         * Required: false
         * Array: false
         */
        this.groupingName = undefined;
        /**
         * The code associated with the type of group item (Customer or Shipment).
         * Required: true
         * Array: false
         */
        this.groupTypeCd = undefined;
        /**
         * Identifies the unique identifier of the Customer or Shipment in the grouping.
         * Required: true
         * Array: false
         */
        this.businessKey = undefined;
        /**
         * The interface employees to whom the group is assigned.
         * Required: true
         * Array: true
         */
        this.assignees = undefined;
        /**
         * The interface employee that created the group.
         * Required: true
         * Array: false
         */
        this.createdBy = undefined;
        /**
         * The interface employee that updated the group.
         * Required: true
         * Array: false
         */
        this.lastUpdatedBy = undefined;
        /**
         * The date and time when the group was updated.
         * Required: true
         * Array: false
         */
        this.lastUpdatedDateTime = undefined;
    }
}
/**
 * Stores default preferences for applications
 */
class ApplicationPreference {
    constructor() {
        /**
         * unique identifier of the UPF_APPLICATION table. this key is generated from a sequence.
         * Required: false
         * Array: false
         */
        this.applicationInstId = undefined;
        /**
         * name of the application. The application name will be decided and created on WSO2 gateway during the API subscription process.
         * Required: false
         * Array: false
         */
        this.applicationName = undefined;
        /**
         * Default preferences for the application.
         * Required: false
         * Array: false
         */
        this.applicationPreference = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transaction.  In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * An update operation uses this to version check the record to ensure another transaction has not updated the row after this transaction had read the row and is now about to update it.
         * Required: false
         * Array: false
         */
        this.recordVersionNbr = undefined;
    }
}
/**
 * Defines the Customers (current) or Shipments (future) in the grouping.  The identifier of the Customer or Shipment is stored in the BUSINESS_KEY column.   Added 12/07/2020  LISG-9036  Renamed from UPF_SHPMT_MGMT_ITEM 03/17/2021  LISG-10806
 */
class GroupItem {
    constructor() {
        /**
         * Identifier of the preference grouping.  This key is generated from a sequence.
         * Required: false
         * Array: false
         */
        this.groupingId = undefined;
        /**
         * Identifies the unique identifier of the Customer or Shipment in the grouping.
         * Required: false
         * Array: false
         */
        this.businessKey = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transaction.  In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class InterfaceAcct {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.acctInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.acctMadCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.parentAcctInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nationalAcctInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.name1 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.name2 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.creditStatusCode = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.locationTypeCode = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.addressLine1 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.addressLine2 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cityName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.stateCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.postalCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.countryCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deletedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.latitudeNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.longitudeNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.zip4RestUs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastCreatedBy = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastCreatedDateTime = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.geoCoordinates = undefined;
        /**
         * Geo coordinations
         * Required: false
         * Array: false
         */
        this.geoCoordinatesGeo = undefined;
        /**
         * The value comes from SCO_CUSTOMER_PROFILE.LOCATION_TYPE_CD.
         *
         * The type of location
         *
         * Valid Values:
         * BusinessCommercialBUSINESS/COMMERCIAL
         * DistributionCenterDISTRIBUTION CENTER
         * GroceryWareHouseGROCERY WAREHOUSE
         * ShoppingMallSHOPPING MALL/STRIP MALL
         * UnversityCollegeUNIVERSITY/COLLEGE
         * ConstructionSiteCONSTRUCTION/UTILITY SITES: CONSTRUCTION SITE
         * ConstructionUtilitySiteCONSTRUCTION/UTILITY SITES: UTILITY SITE
         * GovtMineGOVERNMENT SITES: MINE
         * GovtGasOilFieldGOVERNMENT SITES: NATURAL GAS OR OIL FIELD
         * GovtPostOfficeGOVERNMENT SITES: POST OFFICE
         * GovtMilitaryGOVERNMENT SITES: MILITARY
         * GovtPrisonCorrectionGOVERNMENT SITES: PRISON/CORRECTION FACILITY
         * GovtAirportGOVERNMENT SITES: AIRPORT
         * GovtOtherGOVERNMENT SITES: OTHER GOVERNMENT SITES
         * PierContainerFreightStationPIERS, WHARFS, CFS: CONTAINER FREIGHT STATION
         * PierWharfPIERS, WHARFS, CFS: PIER OR WHARF
         * ResidentialHomeRESIDENTIAL: RESIDENCE
         * ResidentialApartmentRESIDENTIAL: APARTMENT
         * ResidentialPlaceofWorshipRESIDENTIAL: PLACE OF WORSHIP
         * ResidentialSchoolRESIDENTIAL: SCHOOL (K-12)
         * ResidentialCampRESIDENTIAL: CAMP
         * ResidentialFarmRESIDENTIAL: FARM
         * ResidentialPublicStorageRESIDENTIAL: PUBLIC STORAGE FACILITY
         * ResidentialBusinessRESIDENTIAL: BUSINESS OPERATING WITHIN A PRIVATE RESIDENCE
         * ExhibitionConvCtrEXHIBITION SITES: EXHIBITION SITE OR CONVENTION CENTER
         * Required: false
         * Array: false
         */
        this.customerProfileLocationTypeCd = undefined;
    }
}
/**
 * Holds a snapshot of InterfaceAcct. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class InterfaceAcctSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 * Details about employees that process and approve claims.
 */
class InterfaceEmployee {
    constructor() {
        /**
         * Employee Id of the Claims employee.
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         * First Name of the Claims employee.
         * Required: false
         * Array: false
         */
        this.firstName = undefined;
        /**
         * Middle Name of the Supervisor of the Claims employee.
         * Required: false
         * Array: false
         */
        this.middleName = undefined;
        /**
         * Last Name of the Supervisor of the Claims employee.
         * Required: false
         * Array: false
         */
        this.lastName = undefined;
        /**
         * Job Description of the Supervisor of the Claims employee.
         * Required: false
         * Array: false
         */
        this.jobDescription = undefined;
        /**
         * The domicile SIC location for the employee.
         * Required: false
         * Array: false
         */
        this.domicileSicCd = undefined;
        /**
         * The employee id of this employee's supervisor.
         * Required: false
         * Array: false
         */
        this.supervisorEmployeeId = undefined;
        /**
         * Desc: The business phone number of the employee.  It is sourced from HRS_EMPL_PHONE_VW in DB2 for typ_cd = 'B'.  01/10/2019 Added by Cathy
         * Required: false
         * Array: false
         */
        this.businessPhoneTxt = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of InterfaceEmployee. Contains the details at the time on an event. It also provides the previous values if an update occured
 * Details about employees that process and approve claims.
 */
class InterfaceEmployeeSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 * Stores one or more preference groupings for a
 *
 * UI component.  A preference grouping is a collection of one or more user preferences.
 *
 * Added 09/10/2019
 */
class PreferenceGrouping {
    constructor() {
        /**
         * Identifier of the preference
         *
         * grouping.  This key is generated from a sequence.
         * Required: false
         * Array: false
         */
        this.groupingId = undefined;
        /**
         * The logical name of the
         *
         * preference grouping.
         * Required: false
         * Array: false
         */
        this.groupingName = undefined;
        /**
         * The data for the
         *
         * preference grouping in JSON format.
         * Required: false
         * Array: false
         */
        this.groupingPreference = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transaction.  In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * An update operation uses this to version check the record to ensure another transaction has not updated the row after this transaction had read the row and is now about to update it.
         * Required: false
         * Array: false
         */
        this.recordVersionNbr = undefined;
        /**
         * Type of Items.  Added 03/17/2021  LISG-10806
         *
         * Valid Values:
         * CUST - Business key will be CUST_INST_ID
         * SHPMT - This is for future, if Shipment Managment needs to allow user to group specific PROs. In this case Business key will be SHP_INST_ID
         * Required: false
         * Array: false
         */
        this.groupTypeCd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * The list of user IDs assigned to the preference grouping.
         * Required: false
         * Array: true
         */
        this.assigneeEmployeeIds = undefined;
    }
}
/**
 * Stores the userids attached to a
 *
 * preference grouping for a UI component.  Added 09/10/2019
 */
class PreferenceGroupingUser {
    constructor() {
        /**
         * Identifier of the preference
         *
         * grouping.  This key is generated from a sequence.
         * Required: false
         * Array: false
         */
        this.groupingId = undefined;
        /**
         * The user id of the person
         *
         * attached to the preference grouping
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transaction.  In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * An update operation uses this to version check the record to ensure another transaction has not updated the row after this transaction had read the row and is now about to update it.
         * Required: false
         * Array: false
         */
        this.recordVersionNbr = undefined;
    }
}
/**
 * Stores one or more tools that are to be executed for the grouping preference, for example a macro or a script.  Added 01/27/2020
 */
class ToolPreference {
    constructor() {
        /**
         * Identifier of the preference grouping.  This key is generated from a sequence.
         * Required: false
         * Array: false
         */
        this.groupingId = undefined;
        /**
         * Part of identifier of the tool preference for a grouping preference.
         * Required: false
         * Array: false
         */
        this.toolPreferenceSequenceNbr = undefined;
        /**
         * The logical name of the preference grouping.
         * Required: false
         * Array: false
         */
        this.toolName = undefined;
        /**
         * The data for the preference grouping in JSON format.
         * Required: false
         * Array: false
         */
        this.toolPreference = undefined;
        /**
         * Generic filter key value to identify the tool preference.
         * Required: false
         * Array: false
         */
        this.filterKey1 = undefined;
        /**
         * Generic filter key value to identify the tool preference.
         * Required: false
         * Array: false
         */
        this.filterKey2 = undefined;
        /**
         * Generic filter key value to identify the tool preference.
         * Required: false
         * Array: false
         */
        this.filterKey3 = undefined;
        /**
         * Generic filter key value to identify the tool preference.
         * Required: false
         * Array: false
         */
        this.filterKey4 = undefined;
        /**
         * Generic filter key value to identify the tool preference.
         * Required: false
         * Array: false
         */
        this.filterKey5 = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transaction.  In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
    }
}
/**
 * Stores default preferences for ui component
 */
class UiComponentPreference {
    constructor() {
        /**
         * unique identifier of the UI_CMPNT_INST_ID table. this key is generated from a sequence.
         * Required: false
         * Array: false
         */
        this.uiComponentInstId = undefined;
        /**
         * name of the UI component.
         * Required: false
         * Array: false
         */
        this.uiComponentName = undefined;
        /**
         * Default preferences for the UI component. Overrides or augments application default preferences
         * Required: false
         * Array: false
         */
        this.uiComponentPreference = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transaction.  In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * An update operation uses this to version check the record to ensure another transaction has not updated the row after this transaction had read the row and is now about to update it.
         * Required: false
         * Array: false
         */
        this.recordVersionNbr = undefined;
    }
}
/**
 * Stores preferences for user
 */
class UserPreference {
    constructor() {
        /**
         * ID of the user for whom the PREFERENCES apply.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * PREFERENCES for the user applicable to the UI component/application. Overrides or augments application/UI Component default PREFERENCES
         * Required: false
         * Array: false
         */
        this.userPreference = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * The logical name of the user preference. Added 09/10/2019
         * Required: false
         * Array: false
         */
        this.userPreferenceName = undefined;
        /**
         * Generated unique identifier (instead of USER_ID + APP_INST_ID + UI_CMPNT_INST_ID) added 09/11/2019
         * Required: false
         * Array: false
         */
        this.userPrefId = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transaction.  In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * An update operation uses this to version check the record to ensure another transaction has not updated the row after this transaction had read the row and is now about to update it.
         * Required: false
         * Array: false
         */
        this.recordVersionNbr = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { SdkUserPreferenceModule, UserPreferenceApiService, DeleteCustomerGroupPath, DeleteGroupItemPath, DeleteUserPreferenceByIdPath, DeleteUserPreferencesByAppNamePath, DeleteUserPreferencesByAppNameQuery, GetUserPreferenceQuery, GetUserPreferenceResp, GetUserPreferenceByIdPath, GetUserPreferenceByIdResp, ListCustomerGroupsQuery, ListCustomerGroupsResp, UpsertGroupItemRqst, UpsertGroupItemResp, UpsertUserPreferenceQuery, UpsertUserPreferenceRqst, CreatePreferenceGroupingUserRqst, DeletePreferenceGroupingPath, DeletePreferenceGroupingUserPath, GetPreferenceGroupingPath, GetPreferenceGroupingResp, ListAllPreferenceGroupingsQuery, ListAllPreferenceGroupingsResp, ListPreferenceGroupingsForUserPath, ListPreferenceGroupingsForUserQuery, ListPreferenceGroupingsForUserResp, ListUsersForPreferenceGroupingPath, ListUsersForPreferenceGroupingQuery, ListUsersForPreferenceGroupingResp, ListUserPreferencesForPreferenceGroupingPath, ListUserPreferencesForPreferenceGroupingQuery, ListUserPreferencesForPreferenceGroupingResp, UpsertCustomerGroupRqst, UpsertCustomerGroupResp, UpsertPreferenceGroupingRqst, UpsertPreferenceGroupingResp, UpsertUserPreferenceForPreferenceGroupingRqst, UpsertUserPreferenceForPreferenceGroupingResp, DeletePreferenceGroupingToolPath, GetPreferenceGroupingToolPath, GetPreferenceGroupingToolResp, ListPreferenceGroupingToolsPath, ListPreferenceGroupingToolsQuery, ListPreferenceGroupingToolsResp, UpsertPreferenceGroupingToolRqst, UpsertPreferenceGroupingToolResp, PreferenceCustomerGroup, ApplicationPreference, GroupItem, InterfaceAcct, InterfaceAcctSnapshot, InterfaceEmployee, InterfaceEmployeeSnapshot, PreferenceGrouping, PreferenceGroupingUser, ToolPreference, UiComponentPreference, UserPreference };

